<template>
    <div class="container">
      <p>{{ t('determineSoilAmounts') }}</p>
      <EquationBlock :equations="equations" />
      <hr />
      <div class="row">
        <div class="col-sm">
          <FreeInput :input-label="t('soil1Name')" v-model="medium1" />
          <GenericInput
            :input-label="t('soil1AmtPerPot')"
            v-model.number="medium1Amt"
            :conversion-factors="ConversionFactors.basicVolume"
          />
          <!-- Repeat for other soil mediums -->
          <FreeInput :input-label="t('soil2Name')" v-model="medium2" />
          <GenericInput
            :input-label="t('soil2AmtPerPot')"
            v-model.number="medium2Amt"
            :conversion-factors="ConversionFactors.basicVolume"
          />

          <FreeInput :input-label="t('soil3Name')" v-model="medium3" />
          <GenericInput
            :input-label="t('soil3AmtPerPot')"
            v-model.number="medium3Amt"
            :conversion-factors="ConversionFactors.basicVolume"
          />

          <FreeInput :input-label="t('soil4Name')" v-model="medium4" />
          <GenericInput
            :input-label="t('soil4AmtPerPot')"
            v-model.number="medium4Amt"
            :conversion-factors="ConversionFactors.basicVolume"
          />

          <FreeInput :input-label="t('soil5Name')" v-model="medium5" />
          <GenericInput
            :input-label="t('soil5AmtPerPot')"
            v-model.number="medium5Amt"
            :conversion-factors="ConversionFactors.basicVolume"
          />

          <!-- Add additional soil mediums as needed -->

          <FixedUnitInput
            :input-label="t('potCount')"
            v-model.number="potCount"
            :unit="t('pots')"
          />
        </div>
        <div class="col-sm">
          <GenericOutput
            v-for="index in 5"
            :key="index"
            :output-label="`${totalLabel} ${mediums[index - 1]}`"
            :number="computedAmounts[index - 1]"
            :conversion-factors="ConversionFactors.basicVolume"
            :showSplitter="false"
            :should-hide="!mediums[index - 1]"
          />
        </div>
      </div>
    </div>
  </template>

  
  <script>
  import { ref, computed, reactive, watchEffect } from 'vue';
  import FreeInput from '../inputs/FreeInput.vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import GenericOutput from '../inputs/GenericOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { round } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FreeInput,
      GenericInput,
      FixedUnitInput,
      GenericOutput,
      EquationBlock,
    },
    setup() {
        const medium1 = ref("Peat Soil");
        const medium1Amt = ref(0.5);
        const medium2 = ref("Perlite");
        const medium2Amt = ref(0.25);
        // Add additional mediums and their amounts
        const medium3 = ref("");
        const medium3Amt = ref(0);
        // Continue for medium4, medium5, etc., as per the React component
        // ...
        const medium4 = ref("");
        const medium4Amt = ref(0);

        const medium5 = ref("");    
        const medium5Amt = ref(0);

        const { t, tm } = useI18n();

        const totalLabel= ref(t("totalSoil"));

        watchEffect(() => {
            totalLabel.value = t("totalSoil");
        });

        

        // Create a reactive object with a function
        const translations = reactive({
          t: (key) => t(key)
        })

        const equations = computed(() => {
            return tm('SoilCalcEquations');
        });

        
        const potCount = ref(25);
    
        const mediums = computed(() => {
            return [medium1.value, medium2.value, medium3.value, medium4.value, medium5.value];
        });
    
        const computedAmounts = computed(() => {
            return [
                round(medium1Amt.value * potCount.value, 2),
                round(medium2Amt.value * potCount.value, 2),
                round(medium3Amt.value * potCount.value, 2),
                round(medium4Amt.value * potCount.value, 2),
                round(medium5Amt.value * potCount.value, 2),
            ]
        });
    
        return {
            medium1,
            medium1Amt,
            medium2,
            medium2Amt,
            medium3,
            medium3Amt,
            medium4,
            medium4Amt,
            medium5,
            medium5Amt,
           
            potCount,
            computedAmounts,
            ConversionFactors,
            equations,
            mediums,
            t: translations.t,
            totalLabel
        };
    },
  };
  </script>
  